import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../icons";
import { getStreamConfig, listStreamRooms, StreamConfig, StreamRoom } from "../../../api";

const CAMERAS = [
  { id: "rear", labelKey: "panels.live.cameras.rearLabel", noteKey: "panels.live.cameras.rearNote" },
  { id: "left", labelKey: "panels.live.cameras.leftLabel", noteKey: "panels.live.cameras.leftNote" },
  { id: "right", labelKey: "panels.live.cameras.rightLabel", noteKey: "panels.live.cameras.rightNote" },
  { id: "fuel", labelKey: "panels.live.cameras.fuelLabel", noteKey: "panels.live.cameras.fuelNote" },
];

export function LiveAnalysisPanel() {
  const { t } = useTranslation("dashboard");
  const [config, setConfig] = useState<StreamConfig | null>(null);
  const [rooms, setRooms] = useState<StreamRoom[]>([]);

  useEffect(() => {
    Promise.all([getStreamConfig(), listStreamRooms()]).then(([c, r]) => {
      setConfig(c);
      setRooms(r);
    }).catch(() => undefined);
  }, []);

  const isLive = config?.mode === "live";
  const liveRooms = rooms.filter((r) => r.active);

  return (
    <div className="live-grid">
      {CAMERAS.map((cam) => (
        <div key={cam.id} className="live-tile">
          <div className="live-feed">
            <div className="live-feed-overlay">
              <Icon name="video" size={36} />
              <span className="live-feed-label">{t(cam.labelKey)}</span>
              <span className={`live-feed-pending ${isLive ? "live-feed-live" : ""}`}>
                {isLive ? t("panels.live.ready") : t("panels.live.waiting")}
              </span>
            </div>
          </div>
          <div className="live-meta">
            <span className="live-cam-name">{t(cam.labelKey)}</span>
            <span className="live-cam-note">{t(cam.noteKey)}</span>
          </div>
        </div>
      ))}
      <div className="live-explain">
        <Icon name={isLive ? "video" : "alert"} />
        <div>
          <strong>
            {isLive
              ? t("panels.live.clusterActive", { count: liveRooms.length })
              : t("panels.live.mockMode")}
          </strong>
          <p>
            {config?.notice ??
              t("panels.live.noticeFallback", {
                url: config?.livekit_url || t("panels.live.urlUndefined"),
              })}
          </p>
        </div>
      </div>
    </div>
  );
}
